export default __webpack_public_path__ + "static/media/community-one-house.6427ce76.png";